export const CarouselItemProperty = {
  ClassName: 'className',
};

export default {
  CarouselItemProperty,
};
